import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SystemApiService } from '@cv-invision/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { SoftwareCollectorPackageModel } from '../software-collector-packages/model/software-collector-packages.model';

@Injectable()
export class SoftwareCollectorPackagesService {
	private setReloadlListConfirmation = new BehaviorSubject({});
	private getReloadlListListener = this.setReloadlListConfirmation.asObservable();
	constructor(private httpClient: HttpClient, private systemApiService: SystemApiService) {}
	/**
	 * GET - Return list of organizations based on a provider.
	 */
	getPackages(): Observable<any> {
		return this.httpClient.get(`${this.systemApiService.api.orders}/products/inside-maps`);
	}

	/**
	 * get product  by ID
	 */
	getPackageById(id: string): Observable<any> {
		return this.httpClient.get(`${this.systemApiService.api.orders}/products/inside-maps/${id}`);
	}

	/**
	 * Save a new Inside Maps
	 */
	setNewPackage(params: SoftwareCollectorPackageModel): Observable<any> {
		return this.httpClient.post(`${this.systemApiService.api.orders}/products/inside-maps`, params);
	}

	/**
	 * Update a new Inside Maps
	 */
	updatePackage(id: string, params: SoftwareCollectorPackageModel): Observable<any> {
		return this.httpClient.put(`${this.systemApiService.api.orders}/products/inside-maps/${id}`, params);
	}

	/**
	 * Sets component data communication.
	 * @param data
	 */
	setReloadListConfirmation(data: any): void {
		this.setReloadlListConfirmation.next(data);
	}

	/**
	 * Returns si the list should be reloaded.
	 */
	getReloadListConfirmationListener(): Observable<any> {
		return this.getReloadlListListener;
	}
}
